$(document).ready(function() {
  // Homepage banner slider
  if($('.home_slider').length > 0){
    var dataautoplay = $('.home_slider').attr('data-autoplay');
    var dataautoplayspeed = $('.home_slider').attr('data-autoplay-speed');
    if($('.home_slider').attr('data-autoplay') === 'true'){
      $('.home_slider').slick({
        dots: true,
        autoplay: dataautoplay,
        adaptiveHeight: true,
        autoplaySpeed: dataautoplayspeed
      });
    }else{
       $('.home_slider').slick({
        dots: true,
        adaptiveHeight: true
      });
    }

  }
  
  // Featured product slider
  if($('.featured_prdt_section_home .product-grid').length > 0){
    jQuery('.featured_prdt_section_home .product-grid').slick({
      dots: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      rows: 0,
      responsive: [
        {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
        },
        {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
        },
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '20px',
              slidesToScroll: 1,
              autoplay: true
            }
        }
      ]
      
    });
  }
  
  if($('.product_section').length > 0){
    jQuery('.product_section').slick({
      infinite: true,
      slidesToShow: 2,
       autoplay: true,
      autoplaySpeed: 1500,
      slidesToScroll: 1,
      dots:false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            infinite: true,
            centerMode: true,
            centerPadding: '80px',
            arrows:true,
            dots: false
          }
        }
      ]
    });
  }
  
  if($('.testimonial_con').length > 0){
    jQuery('.testimonial_con').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      arrows: false,
      centerMode: true,
      centerPadding: '550px',
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '350px',
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '100px',
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '100px',
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '20px',
          }
        }
      ]
    });
  }
  // Logo Section
  if($('.logo_list').length > 0){
    jQuery('.logo_list').slick({
      slidesToShow: 5,
      arrows:false,
      slidesToScroll: 1,
      responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              arrows:false,
              slidesToScroll: 1,
              autoplay: true
            }
          }
      ]
    });
  }

  // New Collection Slider
  if($('.latest_collection_list').length > 0){
    jQuery('.latest_collection_list').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      adaptiveHeight: true,
      responsive: [
          {
              breakpoint: 767,
               settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                  }
          }
      ]
    });
  }
  
 // custom navigation hover (Header)
  $('.header__inline-menu details').hover(function(){
      $(this).find('summary').trigger('click');
  }, function() {
   var opencheck = $(this).attr('open');
    if (typeof opencheck !== 'undefined' && opencheck !== false) {
      $(this).find('summary').trigger('click');
    }  
  });
  //mobile navigation
  $('.mobile_menu-link.has_submenu span').click(function(e){
    e.preventDefault();
    if($(this).parent().hasClass('active')){
      $(this).parent().removeClass('active');
      $(this).parent().find('.mobile_childmenu-container').slideUp();
    }else{
      $(this).parent().addClass('active');
      $(this).parent().find('.mobile_childmenu-container').slideDown();
    }
  })

  //faq section accordion code
  $('.faq-accordion-heading').click(function(){
    $(this).toggleClass('content-show');
    $(this).parent().find('.faq-content').toggleClass('arrow-animate');
    $(this).parent().find('.faq-content').slideToggle(280);
  });
  
  //blog tag filters
  $('.blog-filters-heading').click(function(){
      $(this).addClass('active-filters');
      $(this).parent().find('.blog-filters-container').addClass('blog-filters-open');
    $('body').addClass('filters-open');
  });
  $('.blog-filter-close').click(function(){
    $('.blog-filters-heading').removeClass('active-filters');
    $(this).parent().find('.blog-filters-container').removeClass('blog-filters-open');
    $('body').removeClass('filters-open');
  });
  if($('.blog-filters-container').length > 0){
    $(document).mouseup(function (e) {
      var container = $(".blog-filters-container");
      if(!container.is(e.target) && container.has(e.target).length === 0) {
        $('.blog-filters-heading').removeClass('active-filters');
        $('.blog-filters-container').removeClass('blog-filters-open');
        $('body').removeClass('filters-open');
      }
    });
  }
  
  // navigation # link stop
  $('.no_link').click(function(e){
      e.preventDefault();
  })

  // active class franchise page
  $('.interview-block').click(function(){
    $(this).toggleClass('active');
  });
  
  // world of dogue slider (Work with us)
  if($('.dogue-word-slider').length > 0){
    $('.dogue-word-slider').slick({
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      slidesToShow: 1
    });
  }
  if($('.our-values-slider').length > 0){
    $('.our-values-slider').slick({
      dots: false,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            centerMode: true,
            centerPadding: '40px',
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
    // resize + orientation change
  $(window).on('resize orientationchange', function() {
    if($('.featured_prdt_section_home .product-grid').length > 0){$('.featured_prdt_section_home .product-grid').slick('resize');}
    if($('.product_section').length > 0){$('.product_section').slick('resize');}
    if($('.logo_list').length > 0){$('.logo_list').slick('resize');}
    if($('.our-values-slider').length > 0){$('.our-values-slider').slick('resize');}
    if($('.dogue-word-slider').length > 0){$('.dogue-word-slider').slick('resize');}
  });
});
